import { get } from "svelte/store";

import GeoHelper from "./GeoHelper";
import AlertsStore from "../Alerts/Store";
import VesselHistoryStore from "../UI/VesselHistory/Store";
import DataFormat from "../Enums/DataFormat";

const DownloadHelper = {};
// TODO: remove this and just point directly to AlertsStore method
DownloadHelper.alerts = () => {
	return AlertsStore.helpers.GetGeoJson.vessels.filtered();
};
DownloadHelper.alertsUrl = (dataFormat) => {
	return DownloadHelper.asLink(DownloadHelper.alerts(), dataFormat);
};

// TODO: remove this and just point directly to AlertsStore method
DownloadHelper.alertsHistoric = () => {
	return AlertsStore.vesselGroup.countSelected() === 0 // AlertsStore.helpers.countSelectedVessels() === 0
		? AlertsStore.helpers.GetGeoJson.paths.all()
		: AlertsStore.helpers.GetGeoJson.paths.display();
};
DownloadHelper.alertsHistoricUrl = (dataFormat) => {
	return DownloadHelper.asLink(DownloadHelper.alertsHistoric(), dataFormat);
};

DownloadHelper.vesselHistoryPoints = () => {
	const points = get(VesselHistoryStore.results.points.raw);
	for (let i = 0; i < points.length; i++) {
		// Don't deliver more data than we need.
		// TODO: use VesselSpireDataPropertyMap[VesselProperty.IMO], etc.
		const imo = points[i].properties.imo;
		const mmsi = points[i].properties.mmsi;
		const timestamp = points[i].properties.timestamp;
		const course = points[i].properties.course;
		const speed = points[i].properties.speed;
		delete points[i].properties;
		points[i].type = "Feature";
		points[i].properties = {
			imo: imo,
			mmsi: mmsi,
			timestamp: timestamp,
			course: course,
			speed: speed
		};
	}
	const allData = GeoHelper.emptyGeoJson(points);
	return allData;
};
DownloadHelper.vesselHistoryPointsCSV = () => {
	const points = get(VesselHistoryStore.results.points.raw);
	const nl = "\n";
	let csv = `"imo","mmsi","coordinates","timestamp","course","speed"${nl}`;
	for (let i = 0; i < points.length; i++) {
		// // Don't deliver more data than we need.
		// TODO: use VesselSpireDataPropertyMap[VesselProperty.IMO], etc.
		const imo = points[i].properties.imo;
		const mmsi = points[i].properties.mmsi;
		const timestamp = points[i].properties.timestamp;
		const course = points[i].properties.course;
		const speed = points[i].properties.speed;
		const coordinates = points[i].geometry.coordinates;
		csv += `"${imo}","${mmsi}","${coordinates}","${timestamp}","${course}","${speed}"${nl}`;
	}
	return csv;
};
DownloadHelper.vesselHistoryPointsUrl = () => {
	return DownloadHelper.asLink(DownloadHelper.vesselHistoryPoints(), DataFormat.JSON);
};
DownloadHelper.vesselHistoryPointsCSVUrl = () => {
	return DownloadHelper.asLink(DownloadHelper.vesselHistoryPointsCSV(), DataFormat.CSV);
};

DownloadHelper.asLink = (data, dataFormat) => {
	let string;
	let mimeType;
	if (dataFormat === DataFormat.JSON) {
		string = JSON.stringify(data);
		mimeType = "application/json";
	}
	else if (dataFormat === DataFormat.CSV) {
		string = data;
		mimeType = "text/csv";
	}
	else if (dataFormat === DataFormat.PNG) {
		string = data;
		mimeType = "image/png";
	}
	else if (dataFormat === DataFormat.JPG) {
		string = data;
		mimeType = "image/jpeg";
	}
	else if (dataFormat === DataFormat.PDF) {
		string = data;
		mimeType = "application/pdf";
	}
	else {
		console.warn("Invalid dataFormat passed to DownloadHelper.asLink");
	}

	const blob = new Blob([string], {
		type: mimeType
	});
	return URL.createObjectURL(blob);
};
DownloadHelper.downloadURI = (uri, name) => {
	let link = document.createElement("a");
	link.download = name;
	link.href = uri;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	link = null;
};
export default DownloadHelper;
